import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=30b87d80&scoped=true&"
import script from "./SidebarItem.vue?vue&type=script&lang=js&"
export * from "./SidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=30b87d80&prod&scoped=true&lang=css&"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=30b87d80&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b87d80",
  null
  
)

export default component.exports